const css = `.tdublG__dot{width:8px;height:8px;border-radius:50%}.tdublG__dot-large{width:16px;height:16px;border-radius:50%}.tdublG__line{width:24px;height:4px;border-radius:4px}.tdublG__square{width:16px;height:16px;border-radius:4px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"dot-large":"tdublG__dot-large","square":"tdublG__square","dot":"tdublG__dot","line":"tdublG__line"};
